import React from 'react';
import Link from 'gatsby-link';

import Button from '@marvelapp/marvel-ui/button';
import Spacing from '@marvelapp/marvel-ui/spacing';
import { InlineGrid } from '@marvelapp/marvel-ui/grid';

import Page from 'marketing-website/components/modules/Page';
import HeroIllustration from 'marketing-website/components/modules/Hero/HeroIllustration';

import assets from 'marketing-website/configs/pages/developers/assets';
import metaData from 'marketing-website/data/metadata.js';

import Features from './Features';
import Showcase from './Showcase';
import BotBot from './BotBot';

export default function DeveloperApi() {
  const pageProps = {
    title: metaData.developers.homepage.title,
    meta: [
      {
        name: 'description',
        content: metaData.developers.homepage.description,
      },
    ],
    header: {
      isLight: true,
      title: 'Developers',
    },
    footer: true,
    banner: false,
  };

  const linkProps = {
    rel: 'noopener noreferrer',
    target: '_blank',
  };

  return (
    <Page {...pageProps}>
      <div className="bg-licorice">
        <HeroIllustration
          title="Let’s build the future of design, together"
          copy="Create amazing tools and integrations for over 2 million users or customise Marvel for your own team."
          color="white"
          imageMaxWidth={760}
          tag="h1"
          {...assets.illustration}
        >
          <Spacing type="margin" size="l" position="top">
            <Spacing type="margin" size="l" sizeM="0" position="bottom">
              <InlineGrid>
                <Link to="/developers/documentation/">
                  <Button
                    size="large"
                    color="slate"
                    hover="white"
                    background="white"
                    shape="rounded"
                  >
                    View the docs
                  </Button>
                </Link>
                <a href="/oauth/applications/" {...linkProps}>
                  <Button
                    size="large"
                    shape="rounded"
                    kind="ghost"
                    hover="white"
                    isReversed
                  >
                    Manage your apps
                  </Button>
                </a>
              </InlineGrid>
            </Spacing>
          </Spacing>
        </HeroIllustration>
        <Features />
        <BotBot />
        <Showcase />
      </div>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/developers/index.js